// extracted by mini-css-extract-plugin
export default {"items":"CheckboxGroup_items__-x2QJ","checkBox":"CheckboxGroup_checkBox__8YcPF"};